module.exports = __webpack_public_path__ + "img/nfts-bg.4d4b7807.png";